import React, { createContext, useContext, useState, useMemo, useCallback, ReactNode } from 'react';

interface ProcessingContextType {
    isProcessing: boolean;
    setIsProcessing: (value: boolean) => void;
}

const ProcessingContext = createContext<ProcessingContextType | undefined>(undefined);

interface ProcessingProviderProps {
    children: ReactNode;
}

export const ProcessingProvider: React.FC<ProcessingProviderProps> = ({ children }) => {
    const [isProcessing, setIsProcessingState] = useState(false);

    const setIsProcessing = useCallback((value: boolean) => {
        setIsProcessingState(value);
    }, []);

    // Memoize context value to prevent unnecessary re-renders
    const value = useMemo<ProcessingContextType>(() => ({
        isProcessing,
        setIsProcessing,
    }), [isProcessing, setIsProcessing]);

    return (
        <ProcessingContext.Provider value={value}>
            {children}
        </ProcessingContext.Provider>
    );
};

export const useProcessing = (): ProcessingContextType => {
    const context = useContext(ProcessingContext);
    if (context === undefined) {
        throw new Error('useProcessing must be used within a ProcessingProvider');
    }
    return context;
};